export const DISPLAY_TYPES = {
  WIDE: 'wide',
  INLINE: 'inline'
};
